/**
 * BD.BlackoutDates: Tools for calculating and formatting blackout dates
 */
window.BD = window.BD || {};
window.BD.BlackoutDates = class {
  constructor(blackoutDateStr) {
    this.blackoutDates = this.buildBlackoutDates(blackoutDateStr);
    this.fnFilterBlackouts = this.filterBlackouts.bind(this);
    this.dateRangeJoin = '-';
  }
  
  buildBlackoutDates(str) {
    if (!str) { return []; }
    
    const lines = str.split('\n'); 
    
    return lines.map(line => {
      if (!line || !line.length) { return null; }
      if (line.startsWith('#')) { return null; }
      
      if (line.length === 3) {
        const dayOfWeek = window.BD.BlackoutDates.WEEKDAYS.indexOf(line.toUpperCase());
        
        if (dayOfWeek === -1) {
          console.error(`Unrecognized day: ${ line }`);
          return null;
        }
        
        return {
          type: window.BD.BlackoutDates.RULE_WEEKDAY,
          dayOfWeek: dayOfWeek,
          filter: window.BD.BlackoutDates.weekdayFilter
        };
      }

      const dateRangeMatches = line.match(/(\d{4})-(\d{2})-(\d{2})\s*-\s*(\d{4})-(\d{2})-(\d{2})/);
      
      if (dateRangeMatches) {
        const fromDate = new Date(`${ dateRangeMatches[1] }-${ dateRangeMatches[2] }-${ dateRangeMatches[3] }`);
        const toDate = new Date(`${ dateRangeMatches[4] }-${ dateRangeMatches[5] }-${ dateRangeMatches[6] }`);

        return {
          type: window.BD.BlackoutDates.RULE_DATE_RANGE,
          fromYear: dateRangeMatches[1],
          fromMonth: dateRangeMatches[2],
          fromDay: dateRangeMatches[3],
          toYear: dateRangeMatches[4],
          toMonth: dateRangeMatches[5],
          toDay: dateRangeMatches[6],
          fromDate,
          toDate,
          fromTstamp: fromDate.getTime(),
          toTstamp: toDate.getTime(),
          filter: window.BD.BlackoutDates.dateRangeFilter
        };
      }

      const dateMatches = line.match(/(\d{4})-(\d{2})-(\d{2})/);
      
      if (dateMatches) {
        const date = new Date(`${ dateMatches[1] }-${ dateMatches[2] }-${ dateMatches[3] }`);
        
        return {
          type: window.BD.BlackoutDates.RULE_DATE,
          year: dateMatches[1],
          month: dateMatches[2],
          day: dateMatches[3],
          date,
          tstamp: date.getTime(),
          filter: window.BD.BlackoutDates.dateFilter
        };
      }
      
      console.error(`Unrecognized rule: ${ line }`);
      return null;
    })
    .filter(rule => !!rule);
  }
  
  filterBlackouts(date) {
    // Note we negate the filter here.  This is because blackout date filters are intended
    // to only return valid dates, but we're trying to find dates that match any blackout, i.e.
    // the ones that are _not_ passed by the blackout filters.
    const matchingBlackoutDate = this.blackoutDates.find(blackoutDate => !blackoutDate.filter(date));
    
    return !matchingBlackoutDate;
  }
  
  buildDateStr(dates, joinStr = '<br />') {
    const validDates = dates.filter(this.fnFilterBlackouts);
    if (!validDates) { return ''; }
    
    validDates.sort((a, b) => (a.getTime() - b.getTime()));

    const validMoments = validDates.map(date => window.moment(date));
    
    const fnRenderDateRange = (d1, d2) => {
      const formattedStart = d1.utc().format(window.BD.BlackoutDates.TOUR_FORMAT);
      const formattedEnd = d2.utc().format(window.BD.BlackoutDates.TOUR_FORMAT);
      
      if (formattedStart != formattedEnd) {
        return `${ formattedStart } ${ this.dateRangeJoin } ${ formattedEnd }`;
      }
      else {
        return formattedStart;
      }
    };

    const stringBuilder = validMoments.reduce((acc, date, idx, validMoments) => {
      const isLast = (idx === (validMoments.length - 1));
      const yesterday = date.clone().subtract(1, 'day');
      const isRangeStart = !(yesterday.isSame(acc.prevDate));

      // If we're starting a new range but have an old range in memory, spit out the previous range
      const prevRangeEnded = (isRangeStart && acc.rangeEnd);

      acc.prevDate = date;

      if (prevRangeEnded) {
        acc.strings.push(fnRenderDateRange(acc.rangeStart, acc.rangeEnd));
        acc.rangeStart = null;
        acc.rangeEnd = null;
      }
      else if (!isLast) {
        acc.rangeEnd = date;

        if (!acc.rangeStart) {
          acc.rangeStart = date;
        }
        
        return acc;
      }

      acc.strings.push(fnRenderDateRange(acc.rangeStart || date, date));
      return acc;
    }, { strings: [], lastDate: null, rangeStart: null, rangeEnd: null });

    return stringBuilder.strings.join(joinStr);
  }
};

window.BD.BlackoutDates.WEEKDAYS = [ 'SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN' ];
window.BD.BlackoutDates.RULE_WEEKDAY = 'weekday';
window.BD.BlackoutDates.RULE_DATE = 'date';
window.BD.BlackoutDates.RULE_DATE_RANGE = 'daterange';
window.BD.BlackoutDates.TOUR_FORMAT = 'ddd MMMM D YYYY';

window.BD.BlackoutDates.dateRangeFilter = function(date) {
  const tstamp = date.getTime();
  return (tstamp < this.fromTstamp) || (tstamp > this.toTstamp);
}

window.BD.BlackoutDates.dateFilter = function(date) {
  const tstamp = date.getTime();
  return (tstamp != this.tstamp);
}

window.BD.BlackoutDates.weekdayFilter = function(date) {
  const day = date.getUTCDay();
  return day != this.dayOfWeek;
}